import { render } from "./KlaviyoDownload.vue?vue&type=template&id=5b477432"
import script from "./KlaviyoDownload.vue?vue&type=script&lang=js"
export * from "./KlaviyoDownload.vue?vue&type=script&lang=js"

import "./KlaviyoDownload.vue?vue&type=style&index=0&id=5b477432&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__